'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useParams, usePathname } from 'next/navigation'
import ChampionshipSidebar from './championship-sidebar'
import CommunityContent from './community-content'
import CreateContent from './create-content'

export default function Sidebar({ session, serverInfoFeatureEnabled }) {
  const params = useParams()
  const pathname = usePathname()

  return (
    <div className="col-span-full flex h-full min-h-0 w-full flex-col overflow-hidden pt-[60px] tablet:items-center tablet:px-6 tablet:pt-11">
      <div className="mb-7 flex h-full min-h-0 w-full flex-col">
        <Link href="/" className="relative">
          <Image
            className="mb-6 h-auto cursor-pointer mobile:w-[40%] tablet:mx-auto tablet:w-1/2"
            src="/img/logos/1248x291.webp"
            alt="Grid Finder - The Ultimate Sim Racing Platform"
            width="1248"
            height="291"
            priority={true}
          />
        </Link>

        {params.communityId && (
          <>
            {!pathname.includes('racing/') && (
              <CommunityContent
                session={session}
                params={params}
                pathname={pathname}
              />
            )}

            {pathname.includes('racing') && pathname.includes('create') && (
              <CreateContent
                params={params}
                pathname={pathname}
                session={session}
                serverInfoFeatureEnabled={serverInfoFeatureEnabled}
              />
            )}
          </>
        )}

        {params.championshipId && !pathname.includes('create') && (
          <ChampionshipSidebar
            params={params}
            pathname={pathname}
            session={session}
            serverInfoFeatureEnabled={serverInfoFeatureEnabled}
          />
        )}
      </div>
    </div>
  )
}
